export default {
  PHONE: {
    mask: '+7 (###) ### ## ##',
    tokens: {
      '#': { pattern: /[0-9]/ },
    },
  },
  PHONE_WRITE: '+#-(###)-###-##-##',
};
